<template>
  <div class="not-found-page">
    <h1>404 Not Found</h1>
    <p>Det ser ut som att denna URL inte existerar.<br />Navigera tillbaka till <router-link to="/">startsidan</router-link> eller klicka dig fram i menyn.</p>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
};
</script>

<style scoped>
.not-found-page {
  margin-top: 20vh;
}
h1 {
  font-family: 'fet', sans-serif;
  font-size: 50px;
  margin-top: 100px;
  text-align: center;
}
p {
  font-family: 'fet', sans-serif;
  font-size: 20px;
  text-align: center;
}
</style>
